import fetch from "../utils/fetch";
import { setAllowRedirect } from "./appActions";
import { redirectTo, alertBackendError } from "../utils";
import { SEARCH_ACTION } from "../actions/constants";

export const searchBarAction = ( action ) => (dispatch, getState) => {
    // console.log( 'processPotentialPageLocationChanges',' [searchBarAction] ');
    dispatch({
        type: SEARCH_ACTION,
        payload: action
    });
};


// WEBPACK FOOTER //
// ./src/actions/searchBarActions.js